import { UserEffects } from './user.effects';
import { TeamEffects } from './team.effects';
import { TaskEffects } from './task.effects';
import { ReviewsEffects } from './reviews.effects';
import { WeightsEffects } from './weights.effects';
import { PerimetersEffects } from './perimeters.effects';
import { DoubtsEffects } from './doubts.effects';
import { FoldsEffects } from './folds.effects';
import { ResourcesEffects } from './resources.effects';

// import { RecoveriesEffects } from './recoveries.effects';
// import { NutritionEffects } from './nutrition.effects';

export const effects: any[] = [UserEffects, TeamEffects, TaskEffects, ReviewsEffects, WeightsEffects, PerimetersEffects, DoubtsEffects, FoldsEffects, ResourcesEffects]; // NutritionEffects, RecoveriesEffects

export * from './user.effects';
export * from './team.effects';
export * from './task.effects';
export * from './reviews.effects';
export * from './weights.effects';
export * from './perimeters.effects';
export * from './doubts.effects';
export * from './folds.effects';
export * from './resources.effects';

// export * from './recoveries.effects';

// export * from './nutrition.effects';
